var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamCase1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_850_4206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4113 31.1047C10.4113 19.4489 19.8602 10 31.516 10H87.6871C99.3429 10 108.792 19.4489 108.792 31.1047V88.8953C108.792 100.551 99.3429 110 87.6871 110H31.516C19.8602 110 10.4113 100.551 10.4113 88.8953V31.1047Z",
    fill: "#FBF8F0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.7795 34.6963C67.385 34.6963 75.937 43.0516 76.4714 53.5594L81.8727 60.7251C82.5478 61.6031 81.8727 63.0193 80.6911 63.0193H76.4714V71.5161C76.4714 74.66 73.9678 77.1807 70.8452 77.1807H68.0321V85.6776H48.3401V72.3941C41.673 69.222 37.0876 62.4528 37.0876 54.5224C37.0876 43.5897 45.8646 34.6963 56.7795 34.6963ZM45.3582 53.3045L50.8719 54.7773L46.821 58.8841C45.8364 59.8471 45.8364 61.4898 46.821 62.4811C47.8056 63.4724 49.4372 63.4724 50.3937 62.4811L54.5009 58.4026L55.9356 63.9539C56.2732 65.3417 57.6797 66.1348 59.0019 65.7666C60.3803 65.3984 61.168 64.0106 60.8023 62.6511L59.3113 57.0714L64.8532 58.5725C66.2035 58.9407 67.6101 58.1477 67.9477 56.7599C68.3134 55.4287 67.5257 54.0125 66.1473 53.6727L60.6335 52.2282L64.6844 48.0931C65.669 47.1301 65.669 45.5157 64.6844 44.496C63.6998 43.5047 62.0682 43.5047 61.1117 44.496L57.0327 48.5745L55.5699 43.0232C55.2323 41.6637 53.8539 40.8707 52.5598 41.2106C51.1533 41.5788 50.3656 42.9666 50.7032 44.3544L52.1941 49.9057L46.6804 48.4046C45.3019 48.0647 43.9235 48.8578 43.5578 50.2739C43.2202 51.5768 44.0079 52.9646 45.3582 53.3045Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_850_4206",
    x: 0.562377,
    y: 0.151122,
    width: 126.52,
    height: 128.14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.03491,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_850_4206"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.22095,
    dy: 4.22095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.51746
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_850_4206"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_850_4206",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamCase1);
export default __webpack_public_path__ + "static/media/TeamCase1.5b85876ab3d588de6e7461d209a750bf.svg";
export { ForwardRef as ReactComponent };